var styleguide = {
  magicNumber: 8,
  // Deprecated. Use spacing instead.
  padding: {
    xSmall: 5,
    small: 10,
    medium: 15,
    large: 20,
    xLarge: 30
  },
  spacing: {
    xxxSmall: 4,
    xxSmall: 8,
    xSmall: 12,
    small: 16,
    medium: 24,
    large: 32,
    xLarge: 40,
    xxLarge: 48,
    xxxLarge: 72
  },
  shadow: {
    inverted: '0 -2px 3px 0 rgba(0, 0, 0, 0.2)'
  },
  font: {
    size: {
      xXXXLarge: 46,
      xXXLarge: 38,
      xXLarge: 28,
      xLarge: 24,
      large: 17,
      medium: 16,
      small: 15,
      xSmall: 12,
      xMSmall: 11,
      xXSmall: 10
    },
    // To do: adjust font families for different screen sizes (medium on mobile is bold on desktop)
    family: {
      regular: "'BlocketSans-Regular', sans-serif",
      bold: "'BlocketSans-Bold', sans-serif",
      medium: "'BlocketSans-Medium', sans-serif",
      display: "'Blocket-Display', sans-serif"
    }
  },
  lineHeight: {
    parameter: 3.8,
    medium: 1.6,
    small: 1.3
  },
  width: {
    bigScreenMax: 1000,
    megaScreenMax: 1400
  },
  device: {
    breakpoint: {
      small: {
        max: '999px'
      },
      large: {
        min: '1000px'
      }
    }
  }
};
export default styleguide;
//# sourceMappingURL=styleguide.js.map